export default {
	title: 'Sčítací operáty a jmenné rejstříky',
	title_advanced: 'Pokročilé vyhledávání',
	title_results: 'Výsledky vyhledávání',
	year_of_census: 'Ročník sčítání',
	street: 'Ulice',
	house_number: 'Číslo domu',
	first_name: 'Jméno',
	surname: 'Příjmení',
	inventary_number: 'Inventární číslo',
	name_register: 'Jmenný rejstřík',
	volume: 'Svazek',
	page: 'Stránka',
	show_people: 'Zobrazit osoby z domů',
	perform_search: 'Vyhledat',
	year: 'Rok',
	street_name: 'Název ulice',
	persons_by_registry: 'Osoby dle rejstříku',
	operates_image: 'Obraz operátů',
	page_text: 'Stránka jmenného rejstříku (inv.č.; svazek; stránka; řádek)',
	no_results: 'Nebyly nalezeny žádné výsledky',
};
